export default [
    {
        path: '/useraffiliate',
        name: 'useraffiliate',
        component: () => import('@/views/menu/affiliate/useraffiliate.vue'),
        meta: {
            pageTitle: 'مدیریت کاربران',
            action: 'show',
            resource: 'OrderManager',
        },
    },
    {
        path: '/useraffiliatesettlement',
        name: 'useraffiliatesettlement',
        component: () => import('@/views/menu/affiliate/useraffiliatesettlement.vue'),
        meta: {
            pageTitle: 'مدیریت پرداخت ها',
            action: 'show',
            resource: 'OrderManager',
        },
    },
]
